/**
 * Nexsoss design tokens.
 *
 * Locked values from initial_plan/SPEC.md §5.2 are mirrored here in TypeScript.
 * The .css counterpart in tokens.css must remain in sync; runtime CSS custom
 * properties are the authoritative source.
 */

export const NX_TOKENS = {
  bg: '#0a0b0d',
  bg2: '#0f1117',
  bg3: '#141820',
  card: '#111418',

  border: 'rgba(255, 255, 255, 0.07)',

  blue: '#2e8fff',
  cyan: '#00e5cc',
  grad: 'linear-gradient(135deg, #2e8fff, #00e5cc)',

  text: '#e8ecf0',
  muted: '#7a8a9a',
  white: '#ffffff',

  error: '#ff4d6a',
  warning: '#ffb547',
  moving: '#ffb547',
  success: '#00e5cc',
  info: '#2e8fff',

  fontHeading: "'Rajdhani', sans-serif",
  fontBody: "'DM Sans', sans-serif",

  radius: '8px',
} as const;

export const NX_STATUS_COLOR = {
  active: NX_TOKENS.cyan,
  idle: NX_TOKENS.muted,
  error: NX_TOKENS.error,
  charging: NX_TOKENS.blue,
  warning: NX_TOKENS.warning,
  offline: 'rgba(255, 255, 255, 0.2)',
  // Distinct from BOTH `warning` (a completed task isn't an issue
  // needing attention) AND `active` (cyan was reused for both at
  // first — confirmed too close to tell apart at a glance, especially
  // with `active`'s pulse animation being the only other cue). Blue
  // reads as calm/neutral/"done" against cyan's energetic "live" tone.
  completed: NX_TOKENS.blue,
  // A door/lift-door mid-transit is transient and worth catching at a
  // glance across a whole table or the building map, not just another
  // `warning` (which also covers things that AREN'T actively changing
  // right now, e.g. a degraded-but-stable component) — `StatusChip`
  // gives this one a strong flash instead of the subtle dot-pulse
  // `active`/others get.
  moving: NX_TOKENS.moving,
} as const;

export type StatusKind = keyof typeof NX_STATUS_COLOR;
